// IAB VAST error codes reference:
// https://wiki.iabtechlab.com/index.php?title=VAST_Error_Codes
export class VastError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'VastError';
    this.vastCode = code;
  }
}